import { TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { CustomerApprovalTablePropsType } from "../../../types/container.type";
import { BaseButton } from "../../../components/button/styled";

export const CustomerApprovaTable: React.FC<CustomerApprovalTablePropsType> = ({ rows, handleNavigateToCustomerDetails }) => {
    const customerApprovalTableHeaders = ["Account Number", "Customer Name", "Status", "Action"];
    return (
        <BaseTable
            headers={customerApprovalTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => (
                    <TableRow key={index}>
                        <TableCell>{row?.accountNumber}</TableCell>
                        <TableCell>
                            {`${row?.firstName?.charAt(0).toUpperCase() + row?.firstName?.slice(1)} ${row?.lastName?.charAt(0).toUpperCase() + row?.lastName?.slice(1)}`}
                        </TableCell>
                        <TableCell>{row?.kycStatus?.charAt(0).toUpperCase() + row?.kycStatus?.slice(1)}</TableCell>
                        <TableCell>
                            <BaseButton
                                variant="contained"
                                sx={{
                                    width: { xl: "70%" }
                                }}
                                disableElevation
                                onClick={(e) => handleNavigateToCustomerDetails(e, row?.id)}
                            >
                                <Typography
                                    variant={"button"}
                                    fontFamily={"inherit"}
                                    fontWeight={"inherit"}
                                    fontSize={"inherit"}
                                    lineHeight={"inherit"}
                                    color={"inherit"}
                                    textTransform={"inherit"}
                                >
                                    View
                                </Typography>
                            </BaseButton>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </BaseTable >
    )
}